import { AnimationEvent } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input
} from '@angular/core';

import animations from './animations';
import { LoaderOverlayService } from './loader-overlay.service';

interface LoaderServiceResource {
  service: LoaderOverlayService;
  removeComponentFromBody(): void;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-loader-overlay',
  standalone: true,
  templateUrl: './loader-overlay.component.html',
  styleUrls: ['./loader-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations
})
export class LoaderOvelayComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private _resource: LoaderServiceResource | undefined;

  readonly message = input<string>('');

  protected isVisible = false;

  set resource(value: LoaderServiceResource) {
    this._resource = value;
  }

  show(): void {
    this.isVisible = true;
    this.cdr.detectChanges();
  }

  hide(): void {
    this.isVisible = false;
    this.cdr.detectChanges();
  }

  onAnimationDone(event: AnimationEvent): void {
    if (event.triggerName === 'fadeInOut') {
      if (event.toState?.toString() === 'false') {
        this._resource?.removeComponentFromBody();
      }
    }
  }
}
